import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './DAL/store';
import FormsApp from "./FormsApp/FormsApp";

const init = () => {
    //const c = document.getElementById('forms-app');//data-form
    //console.log('$forms_root: ',$forms_root);
    //if (!$forms_root) return;

    const $forms_root = document.querySelectorAll('[data-form]');
    $forms_root.forEach($form => {
        const formType = $form.getAttribute('data-form');

        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <FormsApp formType={formType}  />
                </Provider>
            </React.StrictMode>,
            $form
        );
    });


};

init();
